export const splitAtFirstSpace = (value: string) => {
  const valueTrimmed = value.trim();
  if (!valueTrimmed) return [];
  const i = valueTrimmed.indexOf(" ");
  if (i > 0) {
    return [valueTrimmed.substring(0, i), valueTrimmed.substring(i + 1)];
  }
  return [valueTrimmed];
};
